// src/components/Charts/pie/StateChart.jsx
import React, { useContext } from 'react';
import AnalyticsPieCard from './AnalyticsPieCard';
import AuthContext from '../../../contexts/auth-context';
import AppContext from '../../../contexts/app-context';
import { urls } from '../../config/variables';

const STATE_COLORS = {
  'Approved': '#4CAF50',
  'Partially accepted': '#FFC107',
  'Rejected': '#F44336',
};

export default function StateChart() {
  useContext(AppContext);
  useContext(AuthContext);

  return (
    <AnalyticsPieCard
      chartId="echart-container-state"
      endpoint={urls.ANALYSIS_ENCOUNTERS}
      i18n={{
        seriesName: 'Encounters',
        centerLabel: 'Encounter',
        detailsButton: 'States Details',
        dialogTitle: 'All States',
        entityName: 'State',
        noData: 'No data',
      }}
      // This API returns [{ state, state_count }, ...]
      nameKeys={['state']}
      valueKeys={['state_count']}
      parseResponse={(data) => {
        const rows = Array.isArray(data) ? data : [];
        return { rows };
      }}
      baseColors={['#000']} // will be overridden by colorMap
      colorMap={STATE_COLORS}
      othersColor="#000"
      useTopNWithOthers={false} // show all states, no 'Others'
      hideDetails={true}
    />
  );
}